var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFingerprint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6664 12.5835C19.8807 17.6489 18.3836 22.6389 15.4164 26.7499M5.74072 21.3235C6.91712 20.1199 8.33356 15.0063 8.33356 12.5835C8.33347 11.8393 8.47997 11.1024 8.7647 10.4148C9.04943 9.72726 9.4668 9.10251 9.99298 8.57626C10.5192 8.05001 11.1439 7.63256 11.8314 7.34776C12.5189 7.06295 13.2558 6.91636 14 6.91636C14.9963 6.91038 15.9756 7.17477 16.8336 7.68136",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75001 2.07144C11.1018 1.53088 12.5441 1.25213 14 1.25C15.4884 1.24991 16.9622 1.543 18.3373 2.11253C19.7124 2.68207 20.9618 3.51689 22.0142 4.56932C23.0667 5.62176 23.9015 6.8712 24.471 8.24629C25.0406 9.62138 25.3337 11.0952 25.3336 12.5836C25.3336 14.17 25.3336 19.6664 22.5 23.9164M1.73145 16.8336C2.27267 15.4773 2.5885 14.0417 2.66645 12.5836C2.66721 9.82383 3.67471 7.15916 5.50001 5.08928M14 12.5836C14 15.4164 12.5836 23.9164 8.33357 26.75",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerprint);
export default __webpack_public_path__ + "static/media/fingerprint.6b3adb0b4d27eb85235f2dfd1ebcd3fc.svg";
export { ForwardRef as ReactComponent };